const ChimelongTicketMixins = {
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ChimelongConnection', title: '商品绑定' },
      { name: 'ChimelongOrderConnection', title: '订单直连' },
      { name: 'ChimelongNewAccount', title: '关联账号' }
    ])
  }
}
export default ChimelongTicketMixins